export default "__VITE_ASSET__DsEVm4eF__"